import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/auth/_services/auth.service';

@Component({
  selector: 'kt-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  email: string ='';
  password: string ='';

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }

  login(){    
    this.authService.login()
  }

}
